import React from "react";
import logo from "../../assets/solar-panel.png";
import companyLogo from "../../assets/logo.png";
import LoginForm from "./LoginForm";
import SignUpForm from "./SignUpForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

import { useState, useEffect } from "react";

function Home() {
  [form, setForm] = useState("login");

  useEffect(() => {
    const url = "/api/authorize";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        // check if data is {}
        if (Object.keys(data).length === 0) {
          window.location.href = "/sites";
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  if (form == "login") {
    return (
      <div className="flex flex-col md:flex-row h-screen">
        <LoginForm setForm={setForm} />

        {/* Right side: Image */}
        <div className="w-full md:w-3/5 flex flex-col items-center justify-center bg-white">
          <div className="relative w-full h-full">
            <img src={logo} alt="Car on road" className="max-w-full h-auto" />
          </div>
        </div>
      </div>
    );
  }

  if (form == "signup") {
    return (
      <div className="flex flex-col md:flex-row h-screen">
        <SignUpForm setForm={setForm} />

        {/* Right side: Image */}
        <div className="w-full md:w-3/5 flex flex-col items-center justify-center bg-white">
          <div className="relative w-full h-full">
            <img src={logo} alt="Car on road" className="max-w-full h-auto" />
          </div>
        </div>
      </div>
    );
  }

  if (form == "forgotpassword") {
    return (
      <div className="flex flex-col md:flex-row h-screen">
        <ForgotPasswordForm setForm={setForm} />

        {/* Right side: Image */}
        <div className="w-full md:w-3/5 flex flex-col items-center justify-center bg-white">
          <div className="relative w-full h-full">
            <img src={logo} alt="Car on road" className="max-w-full h-auto" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <LoginForm />

      {/* Right side: Image */}
      <div className="w-full md:w-3/5 flex flex-col items-center justify-center bg-white">
        <div className="relative w-full h-full">
          <img src={logo} alt="Car on road" className="max-w-full h-auto" />
        </div>
      </div>
    </div>
  );
}

export default Home;
